import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

const MEETING_SRC =
  "https://meetings.hubspot.com/stephaniealexander/joynamscall?uuid=85822d41-de58-4a04-9ebe-c1b2693e055f&embed=true";
const EMBED_JS = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";

export default function DemoModal({ open, onClose }) {
  const { t } = useTranslation();
  const scriptRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      const s = document.createElement("script");
      s.src = EMBED_JS;
      s.type = "text/javascript";
      s.async = true;
      document.body.appendChild(s);
      scriptRef.current = s;
    }
    return () => {
      document.body.style.overflow = "";
      if (scriptRef.current) {
        scriptRef.current.remove();
        scriptRef.current = null;
      }
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="demo-modal">
      <div className="absolute inset-0 bg-foreground/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-full max-w-3xl max-h-[92vh] flex flex-col rounded-3xl overflow-hidden shadow-2xl">
        <div className="h-1.5 joyn-gradient-bar shrink-0" />
        <button
          data-testid="demo-modal-close"
          onClick={onClose}
          className="absolute top-5 right-4 z-10 p-2 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Close"
        >
          <X size={20} />
        </button>
        <div className="p-6 md:p-8 overflow-y-auto">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-joyn-orange mb-3">{t("demo.eyebrow")}</p>
          <h3 className="font-display font-extrabold text-3xl tracking-tight leading-none mb-6">{t("demo.title")}</h3>
          <div
            className="meetings-iframe-container"
            data-src={MEETING_SRC}
            data-testid="demo-hubspot-embed"
            style={{ minHeight: "620px" }}
          />
        </div>
      </div>
    </div>
  );
}
